import React from "react";
import { Tooltip } from "@learningblocks/interactives/interactive-infographic-components/lib/Tooltip";
import { getHotspotIcon, hotspotImageBySrc } from "../utils/icons";
import {
  getTooltipData,
  getHotspotStyles,
  isContentBoxHotspot,
} from "../utils";

import className from "../../style.module.scss";

export function StandardHotspot(props) {
  const { data, locked, hide, idle, cellSize, device, tooltipDirection } =
    props;

  const { isCorrectVariant, isIncorrectVariant, derivedTooltipText, currOpt } =
    getTooltipData(data);

  const hotspotIcon = getHotspotIcon(
    data,
    locked,
    data.triggered,
    data.postTrigger
  );
  const hotspotStyles = getHotspotStyles(data, cellSize);

  // Add border color for correct options
  if (currOpt?.correctness === "Correct" && !data.triggered) {
    hotspotStyles.borderColor = "#84be60";
  }

  const shouldShowTooltip =
    isIncorrectVariant ||
    (device !== "mob" && derivedTooltipText !== "" && !locked);

  return (
    <div
      className={`${className.hotspot} ${hide ? className.hidden : ""} ${idle ? className.idle : ""} ${isIncorrectVariant ? className.incorrectTooltip : ""} ${isCorrectVariant ? className.correctTooltip : ""}`}
      style={hotspotStyles}
    >
      {isContentBoxHotspot(data)
        ? data.props.image
          ? hotspotImageBySrc(data.props.image)
          : data.props.content
        : hotspotIcon}

      {shouldShowTooltip && (
        <Tooltip
          id={props.id}
          tooltipDirection={tooltipDirection}
          text={derivedTooltipText}
          isIncorrectDropdown={isIncorrectVariant}
          offerReset={currOpt?.offerReset || false}
          changeState={props.changeState}
          changeStateTo={currOpt?.resetOption || 1}
        />
      )}
    </div>
  );
}
